// const lenis = new Lenis({
//   inertia: 0.3,
// });

// lenis.on("scroll", (e) => {});

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }

// requestAnimationFrame(raf);

class Utils {
  // 滑动页面
  static pageScroll(position, diff = 0, duration = 800) {
    jQuery("html,body").animate({ scrollTop: position - diff }, duration);
  }

  // 复制文本到剪贴板
  static copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  // 手风琴初始化
  static accordionInit(toggleEl, targetEl, duration = 300, breakpoint = 99999) {
    jQuery("body").on("click", toggleEl, (e) => {
      if (jQuery(window).width() < breakpoint) {
        jQuery(e.currentTarget).siblings(targetEl).stop().slideToggle(duration);
        jQuery(e.currentTarget).parent().toggleClass("active").siblings().removeClass("active").find(targetEl).slideUp(duration);
      }
    });
  }

  // 携带参数跳转后对元素进行模拟点击
  static clickParamEl(param, selector, elAttr) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);

    const el = jQuery(`${selector}[${elAttr}=${paramValue}]`);

    if (paramValue && el.length) {
      el.click();
    }
  }

  // 防抖
  static debounce(fn, delay, immediate = false) {
    let timer = null;
    let isInvoked = false;

    return function (...args) {
      const context = this;

      clearTimeout(timer);

      if (immediate && !isInvoked) {
        fn.apply(context, args);
        isInvoked = true;

        timer = setTimeout(() => {
          isInvoked = false;
        }, delay);
      } else {
        timer = setTimeout(() => {
          fn.apply(context, args);
          isInvoked = false;
        }, delay);
      }
    };
  }

  // 节流
  static throttle(fn, limit) {
    let lastFunc;
    let lastRan;

    return function (...args) {
      const context = this;
      if (!lastRan) {
        fn.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            fn.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}

const customMethods = {
  run: function () {
    this.init();
    this.appHeight();
    this.wowo();
    this.slider();
    this.headerMenu();
    this.anchorLink();
    this.accordion();
    this.parallax();
    this.paramsFun();
    this.formArrowChange();
    this.formInput();
  },

  // Initialization work
  init: function () {
    jQuery("html").addClass("show-c");

    jQuery('.line-animation-text').each(function () {
      const _this = jQuery(this);
      if (_this.find('br').length) {
        let originText = jQuery(this).html().split('<br>');

        _this.empty();
        originText.map((word, i) => {
          let delay = 0.1 * i;
          _this.append(`<p class="line-wrapper"><span class="line-inner" style="transition-delay: ${delay}s;">${word}</span></p> `);
        })
      } else {
        let words = _this.html().split(' ');
        _this.empty();
        _this.css('display', 'inline-block');

        let currentLine = '';
        let temp = [];
        let count = 0;

        words.forEach(function (word) {
          let testLine = currentLine + word + ' ';
          _this.text(testLine);

          if (_this.width() >= _this.parent().width()) {
            temp.push(currentLine + word);
            currentLine = ' ';
          } else {
            currentLine = testLine;
          }
          _this.text('');

        });

        temp.map((line, i) => {
          let delay = 0.1 * count;
          _this.append(`<p class="line-wrapper"><span class="line-inner" style="transition-delay:${delay}s;">${line}</span></p>`);
          count++;
        })

        if (currentLine) {
          let delay = 0.1 * count;
          _this.append(`<p class="line-wrapper"><span class="line-inner" style="transition-delay:${delay}s;">${currentLine}</span></p>`);
        }
        _this.css('display', 'block');
      }
    });

    jQuery('.word-animation-text').each(function () {
      const _this = jQuery(this);
      let originText = jQuery(this).html().split(' ');
      _this.empty();
      originText.map((word, i) => {
        let delay = 0.05 * i;
        _this.append(`<span class="word-outer"><span class="word-inner" style="transition-delay: ${delay}s;">${word}</span></span> `);
      })
    });
  },

  // Calculate screen height by ignoring the height of the toolbar
  appHeight: function () {
    const doc = document.documentElement;
    doc.style.setProperty("--vh", jQuery(window).innerHeight() * 0.01 + "px");
  },

  // Entry animation
  wowo: function () {
    const _this = this;

    setTimeout(function () {
      let wTop = jQuery(window).scrollTop(),
        wHeight = jQuery(window).height(),
        wBottom = wTop + wHeight;

      jQuery(".wowo:not(.animated)").each(function () {
        let me = jQuery(this),
          meTop = me.offset().top,
          meHeight = me.height(),
          meBottom = meTop + meHeight,
          limitTop = wTop - meHeight,
          limitBottom = wBottom + meHeight;

        if (meTop > limitTop && meBottom < limitBottom) {
          me.addClass("animated");
        }
      });

      jQuery(".scroll-number:not(.active)").each(function () {
        let me = jQuery(this),
          meTop = me.offset().top,
          meHeight = me.height(),
          meBottom = meTop + meHeight,
          limitTop = wTop - meHeight,
          limitBottom = wBottom + meHeight;

        if (meTop > limitTop && meBottom < limitBottom) {
          me.addClass("active");
          _this.numberScroll(me, 1500);
        }
      });
    }, 100);
  },

  // Number scrolling increases
  numberScroll: function (selector, duration) {
    let num = jQuery(selector),
      targetValue = parseFloat(num.text()),
      startValue = 0,
      increment = targetValue / (duration / 10);

    let interval = setInterval(function () {
      startValue += increment;
      if (startValue >= targetValue) {
        startValue = targetValue;
        clearInterval(interval);
      }

      let decimalPlaces = targetValue % 1 === 0 ? 0 : (targetValue.toString().split(".")[1] || []).length;
      let formattedValue = startValue.toFixed(decimalPlaces);

      if (num.attr("formatted") == "true") {
        num.text(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      } else {
        num.text(formattedValue);
      }
    }, 10);
  },

  // Header interactional
  headerMenu: function () {
    jQuery("body").on("click", ".hamburger", function () {
      jQuery("html").toggleClass("body-hidden");
      jQuery(this).toggleClass("active");
    });
  },

  // Sticky header
  headerSticky: Utils.throttle(function () {
    if (jQuery(document).scrollTop() > 60) {
      jQuery("header").addClass("sticky");
    } else {
      jQuery("header").removeClass("sticky");
    }
  }, 50),

  // Anchor link scroll effect
  anchorLink: function () {
    jQuery("body").on("click", "a", (e) => {
      if (jQuery(e.target.hash).length) {
        e.preventDefault();

        let anchorPosition = jQuery(e.target.hash).offset().top,
          headerHeight = 0;

        jQuery(".hamburger.active").click();

        Utils.pageScroll(anchorPosition, headerHeight);
      }
    });
  },

  formArrowChange: function () {
    let input = jQuery(".landing-block input[type='email']").val();
    let form = jQuery(".landing-block form");
    if (input.length) {
      form.addClass("filled");
    } else {
      form.removeClass("filled");
    }
  },

  formInput: function () { 
    _this = this;
    jQuery("body").on("input", ".landing-block input[type='email']", function () {
      _this.formArrowChange();
    });
  },

  // Parallax
  parallax: function () {
    let sTop = jQuery(document).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = sTop + wHeight;

    jQuery(".parallax").each(function () {
      let me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.outerHeight(),
        meBottom = meTop + meHeight,
        limitTop = meTop - wHeight,
        progress = 0,
        speed = me.attr("speed") ? Number(me.attr("speed")) : 1;
      if (speed < 0) {
        speed /= 2;
      }

      if (sTop < limitTop) {
        progress = 0;
      } else if (sTop > meBottom) {
        progress = 1;
      } else {
        progress = (sTop - limitTop) / (meBottom - limitTop);
      }
      me.css("transform", "translateY(" + progress * speed * 100 + "%)");
    });

    jQuery(".parallax-inner").each(function () {
      let me = jQuery(this),
        target = me.children(),
        meTop = me.offset().top,
        meHeight = me.outerHeight(),
        meBottom = meTop + meHeight,
        limitTop = meTop - wHeight,
        progress = 0;

      if (sTop < limitTop) {
        progress = 0;
      } else if (sTop > meBottom) {
        progress = 1;
      } else {
        progress = (sTop - limitTop) / (meBottom - limitTop);
      }

      target.css("translate", "0 " + progress * 25 + "%");

    })
  },

  // Accordion
  accordion: function () {
    Utils.accordionInit(".acc-head", ".acc-body");
  },

  // Sliders
  slider: function () {
    // if(jQuery('.slider').length > 0){  
    //     jQuery('.slider').slick({
    //         slidesToShow: 3,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         dots: false,
    //         autoplay: false,
    //         pauseOnHover: false,
    //         pauseOnFocus: false,
    //         infinite: false,
    //         speed: 500,
    //         autoplaySpeed: 5000,
    //         prevArrow: jQuery('.webinars-gallery .slider-toggle-bar .icon-prev'),
    //         nextArrow: jQuery('.webinars-gallery .slider-toggle-bar .icon-next'),
    //         responsive: [
    //             {
    //                 breakpoint: 992,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 1,
    //                 }
    //             },
    //             {
    //                 breakpoint: 576,
    //                 settings: {
    //                     slidesToShow: 1,
    //                     slidesToScroll: 1,
    //                 }
    //             }
    //         ]
    //     });
    // }
  },

  paramsFun: function () {
    Utils.clickParamEl("tag", ".btn", "data-tag");
  },
};

jQuery(document).ready(function () {
  customMethods.run();
});

jQuery(window).scroll(function () {
  customMethods.wowo();
  customMethods.headerSticky();
  customMethods.parallax();
});

jQuery(window).resize(function () {
  customMethods.appHeight();
});